export default __webpack_public_path__ + "static/media/rasm3.4cb75cbf.jpg";